/**
 * CategorySet entity class
 */

import { complement } from 'app/helpers/fn'
import { property } from 'app/helpers/object'

/**
 * CategorySetFactory
 * returns CategorySet entity class
 *
 * @class CategorySetFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.CategorySet} class
 *
 * @ngdoc factory
 * @name mwApp.factory:CategorySetFactory
 */
/* @ngInject */
export default function CategorySetFactory (Entity, SubCategory, Type, m2mMixin) {
  /* === CategorySet class === */

  /**
   * CategorySet model
   *
   * @class CategorySet
   * @classdesc CategorySet model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.m2mMixin
   * @param {Object} [object] - initial object, containing CategorySet entity fields
   * @return {models.CategorySet} CategorySet entity
   */
  function CategorySet () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  CategorySet.prototype = Object.create(Entity.prototype)
  CategorySet.prototype.constructor = CategorySet

  /* === CategorySet instance methods & fields === */

  Object.assign(CategorySet.prototype, {

    /**
     * instance fields
     *
     * @memberof models.CategorySet#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      categories: ['Category'],
      categorySetType: Type(String('VOD')),
      networks: Type.Stump(['Network'], ['id'])
    },

    /**
     * url template
     *
     * @memberof models.CategorySet#
     * @type {String}
     */
    _urlTemplate: 'api/sets/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.CategorySet#
     * @type {String}
     */
    _publicUrlTemplate: 'sets/{{::id}}',

    /**
     * Prepare object
     *
     * @memberof models.CategorySet#
     * @override
     */
    _prepare: function () {
      // sort out categories and subcategories, because they received in a plain list
      if (Array.isArray(this.categories)) {
        this.categories.forEach((cat) => {
          if (cat.parentCategory) {
            // create SubCategory from Category doing skinDeep=true constructor (don't go recursion, just copy fields)
            cat.parentCategory.subCategories.push(new SubCategory(cat, null, true))
          }
        })
        this.categories = this.categories.filter(complement(property('parentCategory')))
      }
    },

    /**
     * Count all subcategories
     *
     * @memberof models.CategorySet#
     * @return {Number}
     */
    _subcategoriesCount: function () {
      if (this.categories && this.categories.length > 0) {
        return this.categories
          .reduce(function (sum, cat) { return sum + (cat.subCategories ? cat.subCategories.length : 0) }, 0)
      }
      return 0
    }

  }, m2mMixin('networks'))

  /* === CategorySet static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(CategorySet, Entity)
  CategorySet._name = 'CategorySet'
  CategorySet.init()

  // permissions
  CategorySet.access = {
    view: 'viewTvChannelCategory viewRadioChannelCategory viewVodCategory viewTvShowCategory | | |',
    create: 'createTvChannelCategory createRadioChannelCategory createVodCategory createTvShowCategory | | |',
    edit: 'editTvChannelCategory editRadioChannelCategory editVodCategory editTvShowCategory | | |',
    delete: 'deleteTvChannelCategory deleteTvChannelCategory deleteVodCategory deleteTvShowCategory | | |'
  }

  return CategorySet
}
